<template>
    <UiModal :is-open="showModal" @close="closeModal">
        <template #content>
            <div class="flex flex-row items-center gap-6">
                <!-- Card Image - Left Column -->
                <div class="w-1/2">
                    <img
                        :src="`${cdnUrl}/uploads/marketing/csp100klto_popup_img.png`"
                        alt="Chase Sapphire Preferred® Card"
                        class="w-full"
                    />
                </div>

                <!-- Offer Details - Right Column -->
                <div class="w-1/2 text-left pr-6 pt-6">
                    <h3 class="text-center mb-5">
                        <span class="text-2xl font-extrabold text-orange">
                            🎉🎉 Limited Time Offer 🎉🎉
                        </span>
                        <span
                            class="block text-lg font-bold mt-1 text-gray-700"
                        >
                            on Our #1 Travel Card
                        </span>
                    </h3>
                    <p class="mb-2 text-lg">
                        The
                        <a
                            href="https://go.10xtravel.com/chase-sapphire-preferred/?utm_medium=my10x&utm_campaign=csp100kLTOpopup/"
                            target="_blank"
                            class="inline-block text-orange hover:text-[#E03A19];"
                        >
                            Chase Sapphire Preferred® Card
                        </a>
                        has a limited-time welcome offer of
                    </p>
                    <p class="mb-4 text-lg font-bold">
                        <span class="text-red-500 font-bold">🚨</span>
                        100,000 bonus points
                        <span class="text-red-500 font-bold">🚨</span>
                    </p>
                    <p class="mb-4 text-lg">
                        after $5,000 in purchases in your first 3 months from
                        account opening.
                    </p>

                    <p class="mb-2 text-lg font-semibold">
                        And based on your My10x wallet information, we think
                        you're eligible for this offer!
                    </p>

                    <!-- CTA Link -->
                    <div class="text-center">
                        <a
                            href="https://go.10xtravel.com/chase-sapphire-preferred/?utm_medium=my10x&utm_campaign=csp100kLTOpopup/"
                            target="_blank"
                            class="inline-block text-orange hover:text-[#E03A19] font-bold text-lg transition duration-200 ease-in-out my-4 pulse-animation"
                            @click="closeModal"
                        >
                            👉 Learn More Here 👈
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </UiModal>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/app';
import { ref, watch, inject, computed } from 'vue';
import UiModal from '@/components/ui/modal/ui-modal.vue';

const $cookies = inject('$cookies');

const appStore = useAppStore();
const { showCspPopup } = storeToRefs(appStore);

const showModal = ref(false);
const cdnUrl = computed(() => window.cdnUrl);

const closeModal = () => {
    showModal.value = false;
    $cookies.set('csppopup', 'true', {
        path: '/',
        expires: 365,
        domain: window.location.hostname,
        secure: true,
    });
};

watch(showCspPopup, (val) => {
    if (!$cookies.get('csppopup')) {
        showModal.value = val;
    }
});
</script>

<style scoped>
/* Override padding for this specific modal */
:deep(.ui-modal-content) {
    padding: 0 !important;
}

:deep(.ui-modal-header) {
    padding: 0 !important;
}

:deep(.ui-modal-footer) {
    padding: 0 !important;
}

/* Pulsing animation for the CTA link */
@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

.pulse-animation {
    animation: pulse 1.5s infinite ease-in-out;
}
</style>
